import { IntlContext } from "context";
import React, { useContext } from "react";

export interface Options {
    value: string | number;
    label: React.ReactNode;
}

export interface SelectProps
    extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    options: Array<Options>;
    placeholder?: string;
    name: string;
    removeEmptyValue?: boolean;
}

const Select: React.FC<SelectProps> = ({
    placeholder,
    options,
    className = "field-control__select",
    removeEmptyValue,
    ...props
}) => {
    const intl = useContext(IntlContext);

    return (
        <React.Fragment>
            <select className={className} {...props}>
                {!removeEmptyValue && placeholder !== undefined && (
                    <option value={""}>{placeholder || intl.formatMessage("generic.form.select.placeholder")}</option>
                )}
                {options.map((option) => (
                    <option key={option.value} value={option.value} title={"" + option.label}>
                        {option.label}
                    </option>
                ))}
            </select>
        </React.Fragment>
    );
};

export default Select;
